import globalAxios from "../../../util/Api";
import { GET_RESOURCE_PLANNING, START_LOADING, STOP_LOADING, ERROR } from "./types";
import { LogoutAction } from "../../../actions";

export const GetResourePlanningExl = (yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/resource_planning?year=${yearField}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/vnd-xls' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_RESOURCE_PLANNING, payload: href })
        }

      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
